<template>
<div>
    <div
        id="lighting"
        class="wrapper"
    >
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 照明 -->
        <app-error-list />
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="照明">1</parts-arrow>
                <span>主たる居室の照明設備の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="主たる居室の照明設備"
                class="flex_column lighting"
                name="ls_main_setti"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.ls_main_setti"
                    v-model="ls_main_setti"
                    :value="value"
                    unit=""
                    :key="'ls_main_setti' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="照明器具の種類"
                    name="ls_main_design"
                    @click="guideTransition"
                    v-if="ls_main_setti == 2"
                >
                    <app-radio
                        v-for="(name, value) in master.ls_main_design"
                        v-model="ls_main_design"
                        :value="value"
                        unit=""
                        :key="'ls_main_design' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
                <app-radio-sub-box
                    label="多灯分散照明方式"
                    name="ls_main_multi"
                    @click="guideTransition"
                    v-if="isMainMulti"
                >
                    <app-radio
                        v-for="value in ['1', '2']"
                        v-model="ls_main_multi"
                        :value="value"
                        unit=""
                        :key="'ls_main_multi' + value"
                    >
                        {{master.ls_main_multi[value]}}
                    </app-radio>
                </app-radio-sub-box>
                <app-radio-sub-box
                    label="調光が可能な制御"
                    name="ls_main_dimming"
                    @click="guideTransition"
                    v-if="ls_main_setti == 2"
                >
                    <app-radio
                        v-for="value in ['2', '1']"
                        v-model="ls_main_dimming"
                        :value="value"
                        unit=""
                        :key="'ls_main_dimming' + value"
                    >
                        {{master.ls_main_dimming[value]}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
        </app-section>
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="照明">2</parts-arrow>
                <span>その他の居室の照明設備の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                v-if="isSonotanokyoshitu"
                :available="true"
                label="その他の居室の照明設備"
                class="flex_column lighting"
                name="ls_general_setti"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.ls_general_setti"
                    v-model="ls_general_setti"
                    :value="value"
                    unit=""
                    :key="'ls_general_setti' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="照明器具の種類"
                    name="ls_general_device"
                    @click="guideTransition"
                    v-if="ls_general_setti == 2"
                >
                    <app-radio
                        v-for="(name, value) in master.ls_general_device"
                        v-model="ls_general_device"
                        :value="value"
                        unit=""
                        :key="'ls_general_device' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
                <app-radio-sub-box
                    label="調光が可能な制御"
                    name="ls_general_dimming"
                    @click="guideTransition"
                    v-if="ls_general_setti == 2"
                >
                    <app-radio
                        v-for="value in ['2', '1']"
                        v-model="ls_general_dimming"
                        :value="value"
                        unit=""
                        :key="'ls_general_dimming' + value"
                    >
                        {{master.ls_general_dimming[value]}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
        </app-section>
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="照明">3</parts-arrow>
                <span>非居室の照明設備の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                v-if="isHikyoshitsu"
                :available="true"
                label="非居室の照明設備"
                class="flex_column lighting"
                name="ls_other_setti"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.ls_other_setti"
                    v-model="ls_other_setti"
                    :value="value"
                    unit=""
                    :key="'ls_other_setti' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="照明器具の種類"
                    name="ls_other_device"
                    @click="guideTransition"
                    v-if="ls_other_setti == 2"
                >
                    <app-radio
                        v-for="(name, value) in master.ls_other_device"
                        v-model="ls_other_device"
                        :value="value"
                        unit=""
                        :key="'ls_other_device' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
                <app-radio-sub-box
                    label="人感センサー"
                    name="ls_other_control"
                    @click="guideTransition"
                    v-if="ls_other_setti == 2"
                >
                    <app-radio
                        v-for="value in ['2', '1']"
                        v-model="ls_other_control"
                        :value="value"
                        unit=""
                        :key="'ls_other_control' + value"
                    >
                        {{master.ls_other_control[value]}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
        </app-section>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版照明情報入力画面
 * 
 * [算出プロパティ]
 * isSonotanokyoshitu ... その他の居室が存在するか
 * isHikyoshitsu ... 非居室が存在するか
 * isMainMulti ... 主たる居室に多灯分散照明方式が採用されているか
 * 他は詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageManualLighting",
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'ls_main_setti',
            'ls_main_design',
            'ls_main_multi',
            'ls_main_dimming',
            'bsc_kyoshitsu_kousei',
            'bsc_sonotakyoshitsu',
            'ls_general_setti',
            'ls_general_device',
            'ls_general_dimming',
            'bsc_hikyoshitsu',
            'ls_other_setti',
            'ls_other_device',
            'ls_other_control'
        ]),
        /**
         * @return Boolean その他の居室が存在するか
         */
        isSonotanokyoshitu(){
            return (this.bsc_kyoshitsu_kousei == 1 || this.bsc_sonotakyoshitsu == 1)
        },
        /**
         * @return Boolean 非居室が存在するか
         */
        isHikyoshitsu(){
            return (this.bsc_kyoshitsu_kousei == 1 || this.bsc_hikyoshitsu == 1)
        },
        /**
         * @return Boolean 主たる居室に多灯分散照明方式が採用されているか
         */
        isMainMulti(){
            return this.ls_main_setti == 2 && (this.ls_main_design == 1 || this.ls_main_design == 2)
        }
    },
    mixins:[help, master],
    methods:{
        ...mapActions('data', ['update']),
    }
}
</script>

<style scoped>

.lighting >>> .grid_2 .radio_sub_box{
    grid-template-columns: 12em 1fr;
    -ms-grid-columns: 12em 1fr;
}
</style>

